import { getTime } from "../utils/time";

const DateTimeItem = ({
  time,
  creation,
  "data-test-id": dataTestId,
}: {
  time: number;
  creation?: number;
  "data-test-id"?: string;
}): JSX.Element => {
  let timeText = getTime(time);
  if (creation) {
    const creationText = getTime(creation);
    timeText = `${creationText} Edited`;
  }

  return (
    <p className="shrink-0 text-sm mb-1" data-test-id={dataTestId}>
      {timeText}
    </p>
  );
};

export default DateTimeItem;
